/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, July 7th 2022, 10:01:14 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { schemaBuilder, Many2OneIntPKBaseSchema } from "lib/validation";
import {
  ProcessTemplateArtifact,
  ProcessTemplateArtifactValidationSchema,
  ProcessTemplateArtifactSchemaType,
} from "lib/schemas";
import { WritableModel } from "lib/schemas/abstract";
import { ProcessDefinition } from "lib/schemas/service-builder/process-definition/ProcessDefinition";

export enum STAGE_TYPES {
  start = "Process Start Stage",
  default = "General Stage",
  submission = "Submission Stage",
  resubmission = "Resubmission Stage",
  payment = "Payment Stage",
  billing = "Billing Stage",
  signing = "Signing Stage",
  certificate_review = "Document Content Review Stage",
  end = "Process End Stage",
  archive = "Archive Stage",
}

export interface ProcessStage extends ProcessTemplateArtifact, WritableModel<false> {
  stage_name: string;
  stage_type: keyof typeof STAGE_TYPES;
  progress_percentage: number;
  sequence: number;
  is_landing: boolean;
  active: boolean;
  process: ProcessDefinition["id"];
}

type WriteOnlyProcessStage = Omit<ProcessStage, "id">;

export const ProcessStageValidationSchema: ProcessTemplateArtifactSchemaType<WriteOnlyProcessStage> =
  ProcessTemplateArtifactValidationSchema.shape({
    stage_name: schemaBuilder.string().required("Stage name is required"),
    stage_type: schemaBuilder.mixed().oneOf(Object.keys(STAGE_TYPES)).required("Stage type is required"),
    progress_percentage: schemaBuilder.number().default(0),
    sequence: schemaBuilder.number().default(0),
    is_landing: schemaBuilder.boolean().required("Landing setting is required"),
    active: schemaBuilder.boolean().required("Active setting is required"),
    process: Many2OneIntPKBaseSchema().required("Stage Process Definition is required"),
  });
